export const Website = Object.freeze({
  FR: 'WebsiteFR',
  BE: 'WebsiteBE',
  ES: 'WebsiteES',
  PT: 'WebsitePT',
  NL: 'WebsiteNL',
});

export const WebsiteByShopId = Object.freeze({
  65: Website.FR,
  70: Website.BE,
  71: Website.ES,
  72: Website.PT,
  73: Website.NL,
});
